
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skigebied",
      function () {
        return require("private-next-pages/skigebied.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skigebied"])
      });
    }
  